package demos.switch

import androidx.compose.material.Switch
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.*


const val BASIC_SLIDER = "1d75aa6eb1e2aa0bb1a9ac41f53e58ecf39647642acb9c166c21bc40e34235d3"

@Composable
fun BasicSlider() {

//    Slider(
//        slider, onValueChange = {
//
//        }
//    )

    var checked by remember { mutableStateOf(false) }

    Switch(
        checked,
        onCheckedChange = {
            checked = it
        }
    )

}